export default {
  methods: {
    postMessageToParent(action, value) {
      console.log('postMessageToParent', { action, value });
      window.parent.postMessage(
        {
          action,
          value
        },
        '*'
      );
    }
  }
};
